import axios, { AxiosRequestConfig } from 'axios'

import { apiRoutes } from '@/config/api-routes'
import { companiesApi } from '@/lib/axios'
import { Culture } from '@/types/culture'
import { Treatment } from '@/types/treatment'

export type InputFileType = 'mosaic' | 'perimeter' | 'raw_images' | 'geotag'

interface GetURLToUploadFileOptions {
  resumable?: boolean
  type: InputFileType
}

interface GetURLToUploadFileNoResumableOptions
  extends GetURLToUploadFileOptions {
  resumable?: false
  originalFilename?: string
}

interface GetURLToUploadFileResumableOptions extends GetURLToUploadFileOptions {
  resumable: true
  originalFilename: string
}

export async function getURLToUploadFile(
  treatment: Treatment,
  culture: Culture,
  demandId: string,
  {
    originalFilename,
    resumable,
    type,
  }: GetURLToUploadFileResumableOptions | GetURLToUploadFileNoResumableOptions,
  options?: AxiosRequestConfig,
) {
  const { data } = await companiesApi.get<{ url: string }>(
    apiRoutes.getURLToUploadFile(treatment, culture, demandId, type),
    { ...options, params: { resumable } },
  )

  if (!resumable) return data.url

  const { headers } = await axios.post(data.url, null, {
    headers: {
      'x-goog-resumable': 'start',
      'Content-Type': 'application/octet-stream',
      'Content-Disposition': `attachment;filename="${originalFilename}"`,
    },
  })

  return headers.location
}
